import Price from '../../../../../Assets/icons/price.svg'
import { RiArrowDownSLine } from 'react-icons/ri'

function CostFilter({

    showCostFilter, setShowCostFilter, setShowLocationFilter,
    selectedCost, setSelectedCost,
    consumer

}) {
    return (
        <div className="filter_category">
            <button 
                type='button' 
                className={`${showCostFilter ? 'show' : ''}`} 
                onClick={() => {
                    setShowCostFilter(prevState => !prevState)
                    setShowLocationFilter(false)
                }}
            >
                <span>
                    {
                        consumer
                        ?
                            consumer.language === 'english'
                            ?
                                'Cost Range'
                            :
                                'খরচ পরিসীমা'
                        :
                            'খরচ পরিসীমা'
                    }
                </span>
                <RiArrowDownSLine />
            </button>
            <div className={`collapse ${showCostFilter ? 'show' : ''}`}>
                <form>
                    <div className="radio_input">
                        <input 
                            type="radio"
                            value='all-costs'
                            checked={selectedCost === 'all-costs'}
                            onChange={e => setSelectedCost(e.target.value)} 
                        />
                        <label htmlFor="radio4">
                            {
                                consumer
                                ?
                                    consumer.language === 'english'
                                    ?
                                        'All Cost Range'
                                    :
                                        'সকল খরচ পরিসীমা'
                                :
                                    'সকল খরচ পরিসীমা'
                            }
                        </label>
                    </div>
                    <div className="radio_input">
                        <input
                            type="radio"
                            value={3}
                            checked={parseInt(selectedCost) === 3}
                            onChange={e => setSelectedCost(e.target.value)} 
                        />
                        <label htmlFor="radio1">
                            <img src={Price} alt="icon" />
                            <img src={Price} alt="icon" />
                            <img src={Price} alt="icon" />
                        </label>
                    </div>
                    <div className="radio_input">
                        <input
                            type="radio"
                            value={2}
                            checked={parseInt(selectedCost) === 2}
                            onChange={e => setSelectedCost(e.target.value)} 
                        />
                        <label htmlFor="radio2">
                            <img src={Price} alt="icon" />
                            <img src={Price} alt="icon" />
                        </label>
                    </div>
                    <div className="radio_input">
                        <input
                            type="radio"
                            value={1}
                            checked={parseInt(selectedCost) === 1}
                            onChange={e => setSelectedCost(e.target.value)} 
                        />
                        <label htmlFor="radio3">
                            <img src={Price} alt="icon" />
                        </label>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default CostFilter